import { PaginatedResponse, useApi } from '@/api';
import { LinkButton, SmartActivityList } from '@/components';
import { Flex, TableSkeleton, Heading, FlexProps } from '@blockanalitica/ui';
import type { SmartActivityData } from '@/components/SmartActivityList';

interface LatestAllocationsProps extends FlexProps {
  network?: string | null;
}

export default function LatestAllocations({
  network = null,
  ...rest
}: LatestAllocationsProps) {
  const [data, error] = useApi<PaginatedResponse<SmartActivityData[]>>({
    url: '/sparkstar/sll/summary-events/',
    queryParams: {
      p: 1,
      p_size: 5,
      order: 'datetime',
      network
    }
  });

  if (error) {
    throw error;
  }
  if (!data) {
    // TODO: wrong skeleton
    return <TableSkeleton rows={10} columns={6} />;
  }

  return (
    <Flex flexDirection="column" gap="s" {...rest}>
      <Flex flexDirection="row" gap="xs" justifyContent="space-between">
        <Flex flexDirection="row" gap="xs" alignItems="center">
          <Heading size="2">Latest Allocation Activity</Heading>
        </Flex>
        <LinkButton
          to={`/spark-liquidity-layer/allocation-activity${network ? `?network=${network}` : ''}`}
          variant="whiteAndUgly"
          fontSize="-1">
          View all
        </LinkButton>
      </Flex>

      <SmartActivityList data={data.results} />
    </Flex>
  );
}
